/**
 * Swatch Color Script - Optimeret Version
 * 
 * Dette script analyserer produktbilledet for at finde den dominerende farve
 * og anvender den som baggrundsfarve på den tilhørende swatch.
 */

document.addEventListener("DOMContentLoaded", function() {
  console.log("Optimeret swatch color script loaded!");
  
  // Funktion til at håndtere swatches
  function processSwatches() {
    // Find alle .alt-swatch elementer
    document.querySelectorAll(".alt-swatch").forEach(function(swatch) {
      let imgUrl = swatch.getAttribute("data-image");
      if (!imgUrl) return;
      
      // Caching af farver - tjek om vi allerede har beregnet denne URL før
      let cachedColor = sessionStorage.getItem("swatch-color:" + imgUrl);
      if (cachedColor) {
        swatch.style.backgroundColor = cachedColor;
        return;
      }
      
      let img = new Image();
      img.crossOrigin = "Anonymous";
      img.src = imgUrl;
      
      img.onload = function() {
        try {
          let canvas = document.createElement("canvas");
          let ctx = canvas.getContext("2d");
          canvas.width = 5;
          canvas.height = 5;
          ctx.drawImage(img, 0, 0, 5, 5);
          
          // I stedet for at bruge en enkelt pixel, tag en 3x3 matrix fra midten
          // og find den mest dominerende farve
          let colorCounts = {};
          let maxColor = null;
          let maxCount = 0;
          
          // Tjek de 9 pixels i midten (koordinater 1,1 til 3,3)
          for (let x = 1; x <= 3; x++) {
            for (let y = 1; y <= 3; y++) {
              let pixel = ctx.getImageData(x, y, 1, 1).data;
              let r = pixel[0];
              let g = pixel[1];
              let b = pixel[2];
              
              // Lav en simpel RGB-nøgle
              let colorKey = `${r},${g},${b}`;
              
              // Tæl denne farve
              colorCounts[colorKey] = (colorCounts[colorKey] || 0) + 1;
              
              // Tjek om denne farve er mest hyppig
              if (colorCounts[colorKey] > maxCount) {
                maxCount = colorCounts[colorKey];
                maxColor = [r, g, b];
              }
            }
          }
          
          // Hvis vi fandt en dominerende farve, brug den
          if (maxColor) {
            let r = maxColor[0];
            let g = maxColor[1];
            let b = maxColor[2];
            let hexColor = `#${r.toString(16).padStart(2, "0")}${g.toString(16).padStart(2, "0")}${b.toString(16).padStart(2, "0")}`;
            swatch.style.backgroundColor = hexColor;
            
            // Gem i cache
            try {
              sessionStorage.setItem("swatch-color:" + imgUrl, hexColor);
            } catch (e) {
              // Ignorer cache-fejl
            }
          } else {
            // Fallback til den originale metode med en enkelt pixel
            let imageData = ctx.getImageData(2, 2, 1, 1).data;
            let r = imageData[0];
            let g = imageData[1];
            let b = imageData[2];
            let hexColor = `#${r.toString(16).padStart(2, "0")}${g.toString(16).padStart(2, "0")}${b.toString(16).padStart(2, "0")}`;
            swatch.style.backgroundColor = hexColor;
            
            // Gem i cache
            try {
              sessionStorage.setItem("swatch-color:" + imgUrl, hexColor);
            } catch (e) {
              // Ignorer cache-fejl
            }
          }
        } catch (e) {
          console.error("Fejl ved behandling af billede:", e);
        }
      };
      
      img.onerror = function() {
        console.error("Image could not be loaded:", imgUrl);
        swatch.style.backgroundColor = "#CCCCCC"; // Fallback farve
      };
    });
  }
  
  // Kør farve-processeringen
  processSwatches();
  
  // Observer DOM changes for at fange dynamisk indlæste swatches
  const observer = new MutationObserver(function(mutations) {
    let hasSwatchChanges = false;
    
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1 && (
              node.classList && node.classList.contains('alt-swatch') ||
              node.querySelector && node.querySelector('.alt-swatch')
          )) {
            hasSwatchChanges = true;
          }
        });
      }
    });
    
    if (hasSwatchChanges) {
      processSwatches();
    }
  });
  
  // Start observation af hele body for ændringer
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  
  // Lyt til Shopify-events
  document.addEventListener('shopify:section:load', processSwatches);
  document.addEventListener('shopify:section:select', processSwatches);
});

// Eksponér funktionalitet til window-objektet for debugging
window.SwatchColorDebug = {
  reprocess: function() {
    console.log("Manuelt reprocessering af swatches...");
    document.querySelectorAll(".alt-swatch").forEach(function(swatch) {
      swatch.style.backgroundColor = '';
    });
    
    // Fjern sessionStorage cache
    Object.keys(sessionStorage).forEach(function(key) {
      if (key.startsWith("swatch-color:")) {
        sessionStorage.removeItem(key);
      }
    });
    
    // Genprocesser swatches
    document.dispatchEvent(new Event('DOMContentLoaded'));
  }
};